<div class="container-fluid g-0 mb-5">
  <div class="row g-0 m-0 d-flex pt-5 pb-5 ps-5 align-items-center">
    <h2 class="title">{{ "ACCOUNT_LANGUAGE_TITLE" | translate }}</h2>
    <h6 class="subtitle">{{ "ACCOUNT_LANGUAGE_SUBTITLE" | translate }}</h6>
  </div>
  <div class="row g-0 pt-3 justify-content-center">
    <div class="row g-0 justify-content-center">
      <div class="col-md-4 mb-3 p-4 item d-flex justify-content-between" (click)="
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
            ? onRadioChange(Language.English)
            : null
        ">
        <span class="item-title">{{ "ENGLISH" | translate }}</span>
        <label class="radio-container" for="english">
          <input type="radio" name="radio" value="en" [defaultChecked]="true" id="english" class="radio-input"
            [checked]="selectedLanguage === Language.English" />
          <span class="radio-checkmark"></span>
        </label>
      </div>
    </div>
    <div class="row g-0 justify-content-center">
      <div class="col-md-4 mb-3 p-4 item d-flex justify-content-between" (click)="
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
            ? onRadioChange(Language.German)
            : null
        ">
        <span class="item-title">{{ "GERMAN" | translate }}</span>
        <label class="radio-container" for="german">
          <input type="radio" name="radio" value="ge" id="german" class="radio-input"
            [checked]="selectedLanguage === Language.German" />
          <span class="radio-checkmark"></span>
        </label>
      </div>
    </div>
    <div class="row g-0 justify-content-center">
      <div class="col-md-4 mb-3 p-4 item d-flex justify-content-between" (click)="
          authService.isAuthorized([PermissionsEnum.Personalize_modify])
            ? onRadioChange(Language.French)
            : null
        ">
        <span class="item-title">{{ "FRENCH" | translate }}</span>
        <label class="radio-container" for="french">
          <input type="radio" name="radio" value="fr" id="french" class="radio-input"
            [checked]="selectedLanguage === Language.French" />
          <span class="radio-checkmark"></span>
        </label>
      </div>
    </div>
  </div>
</div>